export default function extractQueryParams(url) {
  const { 1: query } = url.split('?')
  if (!query) {
    return {}
  }

  const parts = query.split('&')
  const result = {}

  parts.forEach((part) => {
    const { 0: key, 1: value } = part.split('=')

    result[decodeURIComponent(key)] = decodeURIComponent(value)
  })

  return result
}
